<nz-card nzTitle="Objectives Catalog" [nzLoading]="pageLoading">
  <div class="flex flex-wrap items-center gap-4 mb-4">
    <input
      nz-input
      [(ngModel)]="titleSearch"
      placeholder="Search by title"
      style="width: 240px"
    />
    <button nz-button nzType="primary" [disabled]="tableLoading" (click)="applyFilters()">Apply</button>
    <button nz-button nzType="default" [disabled]="tableLoading" (click)="clearFilters()">Clear</button>
  </div>

  <nz-table
    #objectivesTable
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzTotal]="totalRecords"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>Title</th>
        <th>Expert Title</th>
        <th>Expert Description</th>
        <th>Pillar</th>
        <th>Category</th>
        <th>Active/Paused Assignments</th>
        <th>
          Status
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="statusMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Created</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td>{{ row.title }}</td>
        <td>{{ row.expertTitle || '-' }}</td>
        <td
          class="max-w-xs truncate"
          [title]="row.expertDescription || ''"
        >
          {{ row.expertDescription || '-' }}
        </td>
        <td>{{ row.pillar }}</td>
        <td>{{ row.category || '-' }}</td>
        <td>{{ row.activeUserObjectiveCount }}</td>
        <td>
          <nz-tag *ngIf="row.isArchived" nzColor="red">Retired</nz-tag>
          <nz-tag *ngIf="!row.isArchived" nzColor="green">Active</nz-tag>
        </td>
        <td>{{ row.createdAt | date: 'medium' }}</td>
        <td>
          <button nz-button nzType="link" (click)="viewUsers(row)">
            View Users
          </button>
          <button
            nz-button
            nzType="default"
            nzDanger
            [disabled]="row.isArchived"
            (click)="retireAlert(row)"
          >
            Retire
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onStatusFilterChange($event)">
      <div nz-row class="m-1">
        <label nz-checkbox nzValue="false" [ngModel]="statusFilterValues.includes('false')">
          Active
        </label>
      </div>
      <div nz-row class="m-1">
        <label nz-checkbox nzValue="true" [ngModel]="statusFilterValues.includes('true')">
          Retired
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
